module.exports = __webpack_public_path__ + "img/header-diamondJewelryColliers@2x.4728bca.webp";